    <nb-card>
      <nb-card-header>
        Schedule Social Media Post
    </nb-card-header>
    <!-- <ubs-tasks-container [tasks]="tasks" [selectedValue]="selectedValue">
    </ubs-tasks-container> -->
    <ubs-task-container [selectedTask]="componentTask"></ubs-task-container>
    <!-- <ubs-relation-container [relation]="relation" [relations]="relations" [selectedValue]="selectedValue">
      
    </ubs-relation-container> -->

    </nb-card>
    

  